import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'longDateTime' })
export class LongDateTime extends DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        if (value == undefined || value == '' || value == '/Date(-62135596800000)/') {
            return '';
        } else {
            let s: string = value.toString().replace('/Date(', '').replace('/date(', '').replace(')/', '');
            return super.transform(s, 'MMM/dd/yyyy @ hh:mm a');
        }
    }
}
